import script from "./upSafeguardProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./upSafeguardProduct.vue?vue&type=script&setup=true&lang=js"

import "./upSafeguardProduct.vue?vue&type=style&index=0&id=2dc62763&lang=scss&scoped=true"
import "./upSafeguardProduct.vue?vue&type=style&index=1&id=2dc62763&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc62763"]])

export default __exports__